import { render, staticRenderFns } from "./AddNewStaffModal.vue?vue&type=template&id=431eca60&scoped=true"
import script from "./AddNewStaffModal.vue?vue&type=script&lang=js"
export * from "./AddNewStaffModal.vue?vue&type=script&lang=js"
import style0 from "./AddNewStaffModal.vue?vue&type=style&index=0&id=431eca60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431eca60",
  null
  
)

export default component.exports